import "core-js/modules/es.function.name.js";
import { createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/no-img.bb9c4fe3.png';

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-0331e663"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  id: "newDisc"
};
var _hoisted_2 = {
  key: 0,
  class: "disc-box"
};
var _hoisted_3 = {
  class: "date"
};
var _hoisted_4 = {
  class: "month"
};
var _hoisted_5 = {
  class: "year"
};
var _hoisted_6 = {
  class: "disc"
};
var _hoisted_7 = ["onClick"];

var _hoisted_8 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0
  }, null, -1
  /* HOISTED */
  );
});

var _hoisted_9 = {
  class: "name linelittle"
};
var _hoisted_10 = {
  class: "songer linelittle"
};
var _hoisted_11 = {
  class: "songer-name"
};

var _hoisted_12 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "slash"
  }, "/", -1
  /* HOISTED */
  );
});

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_image = _resolveComponent("el-image");

  var _component_Loading = _resolveComponent("Loading");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_ctx.newDiscList.length ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createCommentVNode(" 左边日期 "), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$filters.formatTime(_ctx.date, "MM")), 1
  /* TEXT */
  ), _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$filters.formatTime(_ctx.date, "YYYY")), 1
  /* TEXT */
  )]), _createCommentVNode(" 右边新碟列表 "), _createElementVNode("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.newDiscList, function (item) {
    return _openBlock(), _createElementBlock("div", {
      class: "disc-item",
      key: item.id,
      onClick: function onClick($event) {
        return _ctx.albumClick(item.id);
      }
    }, [_createVNode(_component_el_image, {
      src: item.picUrl
    }, {
      placeholder: _withCtx(function () {
        return [_hoisted_8];
      }),
      _: 2
      /* DYNAMIC */

    }, 1032
    /* PROPS, DYNAMIC_SLOTS */
    , ["src"]), _createElementVNode("div", _hoisted_9, _toDisplayString(item.name), 1
    /* TEXT */
    ), _createElementVNode("div", _hoisted_10, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.artists, function (songer) {
      return _openBlock(), _createElementBlock("span", {
        class: "songer-item",
        key: songer.id
      }, [_createElementVNode("span", _hoisted_11, _toDisplayString(songer.name), 1
      /* TEXT */
      ), _hoisted_12]);
    }), 128
    /* KEYED_FRAGMENT */
    ))])], 8
    /* PROPS */
    , _hoisted_7);
  }), 128
  /* KEYED_FRAGMENT */
  ))])])) : (_openBlock(), _createBlock(_component_Loading, {
    key: 1
  }))]);
}